module.exports = __webpack_public_path__ + "0599df8ed9f1c5cebbfe292df7a35668.jpg";